import { render, staticRenderFns } from "./ProductCategoryCreate.vue?vue&type=template&id=21849f78&scoped=true"
import script from "./ProductCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21849f78",
  null
  
)

export default component.exports